<script lang="ts" setup>
const { LocalConfigurationStore } = stores()
const heading = computed(() => LocalConfigurationStore.value?.highlightsInfo?.section)
const highlightsInfo = LocalConfigurationStore?.value?.highlightsInfo
</script>

<template>
  <div class="flex flex-col gap-1">
    <TitleComponent
      v-if="heading"
      :text="heading.title"
      :tagline="heading?.subTitle"
    />
    <div class="flex flex-wrap justify-center gap-12">
      <GridComponent :cols="highlightsInfo?.items.length">
        <template
          v-for="(highlight, i) in highlightsInfo?.items"
          :key="i"
        >
          <CardComponent bg="light">
            <template #header>
              <span class="text-sm font-bold uppercase md:text-lg">{{ highlight.title }}</span>
            </template>

            <div class="flex w-full justify-center">
              <ImageComponent
                :src="`/siteAssets/img|highlights/${highlight.artwork}`"
                :alt="highlight.title"
                class="size-14 md:size-16"
              />
            </div>
            <div class="text-center text-[14px]">
              {{ highlight.description }}
            </div>
          </CardComponent>
        </template>
      </GridComponent>
    </div>
  </div>
</template>
